import type { Listing } from '@adc/sdk/types'

const findListingById = (listing: Listing, targetListingId: string) =>
  listing.listing_id === targetListingId

const assetRowCount = (targetIndex: number, numberOfRows: number) =>
  Math.floor(targetIndex / numberOfRows) + 1

export const getTargetRow = (
  targetListingId: string,
  exactMatchList = [],
  nearbyAssetsList = [],
  itemsPerRow: number
) => {
  // Listing can either be located in exact results or in nearby results
  const exactMatchListSelectedAsset = exactMatchList.find(listing =>
    findListingById(listing, targetListingId)
  )

  if (exactMatchListSelectedAsset) {
    // If target listing is part of exact match we just return the target row + header offset
    const exactMatchListTargetIndex = exactMatchList.indexOf(
      exactMatchListSelectedAsset
    )
    const exactMatchListargetRow = assetRowCount(
      exactMatchListTargetIndex,
      itemsPerRow
    )
    return exactMatchListargetRow
  } else {
    const nearbyAssetsListSelectedAsset = nearbyAssetsList.find(listing =>
      findListingById(listing, targetListingId)
    )
    if (nearbyAssetsListSelectedAsset) {
      // If result is on nearby section we need to return the row the asset is in for that list + an offset
      // that offset will depend on whether there are any rows in exact match result sin the first place
      // If no exact matches we need to also account for the section ehader not being present, which results in a -1 offset
      const numberOfExactMatchRowsOffset = exactMatchList.length
        ? assetRowCount(exactMatchList.length - 1, itemsPerRow)
        : -1

      const targetIndex = nearbyAssetsList.indexOf(
        nearbyAssetsListSelectedAsset
      )

      const targetNearbyRow = assetRowCount(targetIndex, itemsPerRow) + 1
      return numberOfExactMatchRowsOffset + targetNearbyRow
    }
  }

  return null
}

export const shouldDisplayAdglareCard = (
  exactMatchList: any[],
  featureFlags: any
) => {
  return (
    exactMatchList.length >
    featureFlags['fe.resi.srp-adglare-configuration']?.position
  )
}

export const getPropertyTotalAmount = (assets: any, isGlobalSearch: string) =>
  isGlobalSearch === 'y' ? assets.total : assets.nearbyTotal
